<template>
	<div class="statistica__per-month">
		<div class="statistica__item">
            <div class="statistica__per-month-title">
                <div class="statistica__per-month-title_text">{{numberWeek}}-я неделя
                    <!--<i class="icon-calendar" @click="showPopup"></i>-->
                </div>
                <div class="statistica__per-month-title_data">
                    <span>
                        <watch :data="profitAbs"
						   :units="'$'"
					   	>
                        </watch>
                    </span>
                    <span>
                        <watch :data="profitPercent"
						   :units="'%'"
						>
                        </watch>
                    </span>
                </div>
            </div>
            <div class="statistica__per-month-row">
                <chart :points = "points" :fixedWidth = "320"
                :fixedHeight = "110" :smooth="false" :data="this.profitAbs"></chart>
            </div>
        </div>
        <transition enter-active-class="animated fadeIn"
				leave-active-class="animated fadeOut">
            <div v-show="popup" class="statistica-popup">
                <div class="statistica-changeDate">
                    <div class="statistica-changeDate-item">
                        <div class="statistica-changeDate-item-options">
                            <span>год</span>
                            <select v-model="yearPeriod" @change="setMonth">
                                <option v-for="(item,index) in years" :key="index">{{item}}</option>u
                            </select>
                        </div>
                        <div class="statistica-changeDate-item-options">
                            <span>месяц</span>
                            <select v-model="monthPeriod" @change="setWeek">
                                <option v-for="(item,index) in monthInYear" :key="index + 'month'">{{item}}</option>u
                            </select>
                        </div>
                        <div class="statistica-changeDate-item-options">
                            <span>неделя</span>
                            <select v-model="weekPeriod">
                                <option v-for="(item,index) in weekInMonth" :key="index + 'week'">{{item.begin}}—{{item.end}}</option>u
                            </select>
                        </div>
                    </div>
                    <input type="button" value="OK" @click="setDate">
                </div>
            </div>
        </transition>
        <transition enter-active-class="animated fadeIn"
				leave-active-class="animated fadeOut">
            <div v-show="popup" class="statistica-overlay"></div>
        </transition>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import Vue from 'vue';
import Chart from '../../../ui-components/ui-mini-linechart';
import Watcher from '../../../ui-components/ui-data-watcher';

export default {
    components: {
        'chart':Chart,
        'watch':Watcher
    },
	data() {
		return {
            weekSum:null,
            numberWeek:0,
            profitAbs:0,
            profitPercent:0,
            points:[],
            popup:false,
            years:null,
            monthInYear:null,
            monthPeriod:null,
            weekPeriod:null,
            yearPeriod:null,
            weekInMonth:null,
            datePeriod:null,
            indexWeek:null,
            month: ['Январь', 'Февраль','Март','Апрель', 'Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь']

		};
	},
	computed: {
		...mapGetters({
              getMonthStat: 'accountstat/getMonthStat',
              getPeriod: 'accountstat/getPeriod',
              getMonthsInYear: 'accountstat/getMonthsInYear'
        }),
        getNumberWeek()
        {
            let lastWeek = []
            lastWeek = this.weekSum.week[this.weekSum.week.length - 1]
            let numberWeek = 0
            numberWeek = lastWeek[lastWeek.length - 1].title
            return numberWeek
        },
	},
	methods: {
		updateData(date, index) {
            let stat = this.getMonthStat('', date, index);
            if (index === null) {
                if(stat.week.length === 0)
                return;
            this.weekSum = stat.week[stat.week.length - 1];
            this.points = this.getPoints(stat, this.indexWeek);
            this.years = this.getPeriod(this.symbol);
            this.numberWeek = this.weekSum[this.weekSum.length - 1].title
            this.profitAbs = this.weekSum[this.weekSum.length - 1].profitAbs
            this.profitPercent = this.weekSum[this.weekSum.length - 1].profitRel
            } else {
                if(stat.length === 0)
                return;
                this.weekSum = stat;
                this.points = this.getPoints(stat, this.indexWeek);
                this.years = this.getPeriod(this.symbol);
                this.numberWeek = this.weekSum[this.weekSum.length - 1].title
                this.profitAbs = this.weekSum[this.weekSum.length - 1].profitAbs
                this.profitPercent = this.weekSum[this.weekSum.length - 1].profitRel
            }

        },
        getPoints(stats, indexWeek) {
            let days = [];
            let lastWeek = null;
            if (indexWeek == null) {
                lastWeek = stats.week[stats.week.length - 1]
            } else {
                lastWeek = stats;
            }
            for (let i = 0; i < lastWeek.length; i++) {
                if(lastWeek[i].weekDayName)
                days.push(lastWeek[i].weekDayName)
            }
            days.unshift('');
            let chartPoints = {
                points:[]
            }; //Data Object for Chart
            chartPoints.points.push(lastWeek[0].equityOnBod)
            for(let i = 0; i < lastWeek.length - 1; i++)
                chartPoints.points.push(lastWeek[i].equityOnEod)
            let profit = [];
            for(let i = 0; i < chartPoints.points.length; i++) {
                if(i != 0) {
                    profit.push(chartPoints.points[i] - chartPoints.points[i - 1])
                }
            }
            let profitPercent = [];
            for(let i = 0; i < chartPoints.points.length; i++) {
                if(i != 0) {
                    profitPercent.push(100/(chartPoints.points[i]/(chartPoints.points[i] - chartPoints.points[i - 1])));
                }
            }
            return chartPoints.points
        },
        showPopup() {
            this.popup = true;
        },
        setMonth() {
            this.monthInYear = getMonthName(this.getMonthsInYear(this.symbol, this.yearPeriod));
        },
        setWeek() {
            let date = new Date (this.yearPeriod, this.month.indexOf(this.monthPeriod));
            this.weekInMonth = getWeeksPeriods(this.getMonthStat(this.symbol, date), this);
        },
        setDate() {
            this.datePeriod = new Date(this.yearPeriod, this.month.indexOf(this.monthPeriod));
            let arrWeek = this.weekPeriod.split('—');
            for(let i = 0; i< this.weekInMonth.length; i++) {
                if(this.weekInMonth[i].begin === arrWeek[0])
                    this.indexWeek = i;
            }
            this.updateData(this.datePeriod,this.indexWeek);
            this.popup = false;
            //this.dateForTitle = this.datePeriod;
            //this.menuDate = false;
        }

	},
	created() {
        subscribeOnUpdate(this.$store, '', isFirstObtained => {
            this.updateData(this.datePeriod,this.indexWeek);

        });
        this.updateData(this.datePeriod,this.indexWeek);
    } // created }
};

function subscribeOnUpdate(store, symbol, handler) {
    store.dispatch("accountstat/subscribeOnUpdate", {
        symbol: "",
        callback: {
            id: "weeks-widget-desktop",
            handler: handler
        }
    });
}

function getMonthName(arrayMonth) {
        let month = ['Январь', 'Февраль','Март','Апрель', 'Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'];
        let monthName = [];
        for(let i = 0; i < arrayMonth.length; i++) {
            monthName.push(month[arrayMonth[i]]);
        }
        return monthName;
}

function getWeeksPeriods(monthStat,context) {
    let endsAndBeginWeeks = [];
    for(let i = 0; i < monthStat.week.length; i++) {
            endsAndBeginWeeks.push({
                begin:context.$datef(monthStat.week[i][0].date, 'd'),
                end:context.$datef(monthStat.week[i][monthStat.week[i].length - 2].date, 'd')
            })
    }
    return endsAndBeginWeeks;
}

</script>

<style lang="less" scoped>
.statistica {
    &-popup {
        position: fixed;
        top:30%;
        left:8px;
        right: 8px;
        max-width: 100%;
        background: #3d536b;
        border-radius: 8px;
        padding: 8px;
        z-index: 10;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    &-overlay {
        position: fixed;
        display: block;
        left: 0;
        margin-right: 8px;
        top:0;
        width: 100%;
        min-height: 100vh;
        background:rgba(0,0,0,0.7);
        z-index: 1;
    }
    &-changeDate {
        display: flex;
        flex-direction: column;
        align-items: center;
        &-item {
            display: flex;
            flex-direction: column;
            &-options {
                display: flex;
                flex-direction: column;
                margin-right: 16px;
                &:last-child {
                    margin-right: 0px;
                }

            }
        }
        select {
            font-family: Montserrat;
            font-weight: 600;
            font-style: normal;
            font-stretch: normal;
            font-size: 120%;
            background: #fff;
            padding: 4px;
            border-radius: 4px;
            width: 280px;
        }
        span {
            font-family: Montserrat;
            font-size: 20px;
            font-weight: 600;
            font-style: normal;
            font-stretch: normal;
            line-height: normal;
            letter-spacing: 0.4px;
            color: #fff;
            margin-right: 16px;
        }
    }
}
input[type="button"]
    {
        height: 40px;
        border-radius: 4px;
        width: 100px;
        background-color: #0fd7b7;
        border: none;
        margin-top: 16px;
        color:#374b62;
        cursor: pointer;
        font-family: Arimo;
        font-size: 13px;
        font-weight: bold;

        &:disabled
        {
            background-color: #718da8;

            &:hover
            {
              background-color: #718da8;
            }
        }

        &:hover
        {
            background-color: @colors[green];
        }
}
.statistica__item {
    margin-bottom: 8px;
    display: block;
    background: #3d536b;
    border-radius: 4px;
    overflow: hidden;
}
.statistica__per-month {
    width: 100%;
    &-title {
        font-family: Montserrat;
        font-weight: normal;
        font-size: 17px;
        font-style: normal;
        font-stretch: normal;
        //text-transform: uppercase;
        color: #ffffff;
        padding-left: 16px;
        background-color: #3d536b;
        border-bottom: 1px solid #374b62;
        margin-bottom: 0px;
        padding: 8px 8px;
        height: 45px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        &_text {
            display: flex;
            align-items: center;
        }
        &_data {
            display: flex;
            align-items: center;
        }
        i {
            margin-left: 8px;
            margin-top: 4px;
        }
        span {
            font-family: Arimo;
            //font-weight: 600;
            margin-right: 8px;
            &:first-child {
                margin-left: 8px;
            }
            &:last-child {
                margin-right: 0px;
            }
        }
    }
    &-row {
       display: flex;
       justify-content: center;
        padding-top: 8px;
    }

    &-item {
        border-top: solid 1px #374b62;
        padding: 0 8px 0 12px;
        height: 29px;
        &-title{
            padding: 8px 0;
            border-bottom: 1px solid #374b62;
            display: flex;
            justify-content: space-between;

            &-day {
                font-family: Arimo;
                font-size: 12px;
                font-style: normal;
                font-stretch: normal;
                line-height: 2;
                letter-spacing: 0.4px;
                text-transform: uppercase;
                padding-left: 16px;
                color: #ffffff;
            }

            &-date {
                font-family: Arimo;
                font-size: 12px;
                font-style: normal;
                font-stretch: normal;
                line-height: 2;
                letter-spacing: 0.4px;
                text-transform: uppercase;
                padding-right: 12px;
                color: #aabed2
            }
        }

        &-data {
            padding: 12px 12px 8px 12px;

            &-sum {
                font-family: Arimo;
                font-size: 13px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.25;
                letter-spacing: 0.4px;
                text-align: left;
            }

            &-pips {
                font-family: Arimo;
                font-size: 13px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.54;
                letter-spacing: 0.4px;
            }

            &-probability {
                font-family: Arimo;
                font-size: 12px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 2;
                letter-spacing: 0.4px;
                text-transform: uppercase;
                color: @colors[green];
                margin-top: 8px;
            }

            &-maxdd {
                font-family: Arimo;
                font-size: 12px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 2;
                letter-spacing: 0.4px;
                color: @colors[red];
                }
        }

        &-chart {
            width: 100%;
            display: block;
            //flex-grow: 1;
            min-height: 200px;
        }
    }
}
</style>
